export const COOKIES = {
  latestSelInves : "latestSelectedInvestorAccount",
  latestSelBroker : "latestSelectedBroker",
  loggedInBrokerUsername : "loggedInBrokerUsername",

  univalsalLinkCallback : "univalsalLinkCallback",
}